import { Environment } from "./env";

export const ProdEnvironment: Environment = {
    client_id: '289322022105-d6kou0ncpfhvmq4g5a3pu81e94t3ni5c.apps.googleusercontent.com',
    client_secret: 'tomq8DmgKdyFLzVeA6ZKtBXt',
    apiKey: '08a853365fmshabd73e3a4a5c402p1d5578jsn2b7438331f7c',
    url: 'https://paiza-io.p.rapidapi.com/runners'
}